import { apiPost } from "./api";
import { getRecaptchaToken } from "./recaptcha";

export interface FranchiseEnquiry {
  applicantName: string;
  company: string;
  targetCity: string;
  investmentRange: string;
  contactEmail: string;
}

/**
 * Routes a franchise enquiry to Business Development: mints a reCAPTCHA v3 token, then
 * POSTs to the real `/api/public/enquiries/franchise` endpoint (verifies the token, writes
 * the enquiry to Firestore, returns a server-issued reference number) — same pattern as
 * supplierEnquiry.ts. No client-side simulation.
 */
export async function submitFranchiseEnquiry(
  enquiry: FranchiseEnquiry,
): Promise<{ ok: true; referenceNumber: string }> {
  const recaptchaToken = await getRecaptchaToken("franchise_enquiry");
  return apiPost<{ ok: true; referenceNumber: string }>("/public/enquiries/franchise", {
    ...enquiry,
    recaptchaToken,
  });
}
